import { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { user_login } from "../../api/Auth"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
const SignIn = () => {
      const navigate = useNavigate();
      const [showPassword, setShowPassword] = useState(false);
      const [formData, setFormData] = useState({
            email: "",
            password: "",
            remember: false
      });

      const [loading, setLoading] = useState(false);
      const [error, setError] = useState("");

      // Handle input change
      const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFormData({
                  ...formData,
                  [name]: type === "checkbox" ? checked : value
            });
      };

      // Handle form submission
      // const handleSubmit = async (e) => {
      //       e.preventDefault();
      //       setLoading(true);
      //       setError("");

      //       const formDataToSend = new FormData();
      //       formDataToSend.append("email", formData.email);
      //       formDataToSend.append("password", formData.password);
      //       formDataToSend.append("remember", formData.remember ? "true" : "false");

      //       try {
      //             const response = await axios.post(
      //                   "http://122.160.154.127:8080/api/web-user-login",
      //                   formDataToSend,
      //                   { headers: { "Content-Type": "multipart/form-data" } }
      //             );

      //             alert("Login successful!");
      //             if (response.data?.token) {
      //                   localStorage.setItem("token", response.data?.token)
      //                   localStorage.setItem("user", JSON.stringify(response.data?.data))
      //                   localStorage.setItem("is_user_active",true)
      //                   navigate("/home");
      //             }
      //             console.log(response.data);
      //       } catch (error) {
      //             setError(error.response?.data?.message || error.message || "Login failed. Please try again.");
      //       } finally {
      //             setLoading(false);
      //       }
      // };

      const handleSubmit = async (e) => {
            e.preventDefault();
            if (formData?.password?.length < 8) {
                  setError("The password field must be at least 8 characters.")
                  setLoading(false)
                  return
            }
            setLoading(true);
            setError("");

            const formDataToSend = new FormData();
            formDataToSend.append("email", formData.email);
            formDataToSend.append("password", formData.password);
            formDataToSend.append("remember", formData.remember ? "true" : "false");

            try {
                  const response = await user_login(formDataToSend); // Use global function

                  if (response?.token) {
                        localStorage.setItem("token", response.token);
                        localStorage.setItem("user", JSON.stringify(response.data));
                        localStorage.setItem("is_user_active", "true");
                        toast.success("Login successful!");
                        setTimeout(() => {
                              navigate("/home");
                        }, 1000)
                  } else {
                        setError(response?.error || "Login failed. Please try again.");
                  }
            } catch (error) {
                  setError("An unexpected error occurred. Please try again.");
            } finally {
                  setLoading(false);
            }
      };


      return (
            <>
                  <Header />
                  {/* <-------- ToastContainer ------------> */}
                  <ToastContainer style={{ marginTop: "120px" }} />
                  <section className="relative overflow-hidden py-10 md:py-24">
                        <div className="absolute inset-0 -z-10 bg-[#111315]"></div>
                        <div className="absolute inset-0 -z-10 theme-hero-bg"></div>
                        <div className="absolute inset-0 -z-10 theme-grid-overlay" />
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 relative">
                              <div className="flex flex-col items-center justify-center">
                                    <div className="w-full rounded-xl border border-amber-500/20 bg-[#252b33]/95 shadow-2xl backdrop-blur-xl sm:max-w-md">
                                          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                                                <h1 className="text-xl font-bold leading-tight tracking-tight text-white md:text-2xl">
                                                      Sign in to your account
                                                </h1>

                                                {error && (
                                                      <div className="text-red-500 text-sm font-medium">
                                                            {error}
                                                      </div>
                                                )}

                                                <form className="space-y-4" onSubmit={handleSubmit}>
                                                      {/* Email Field */}
                                                      <div>
                                                            <label className="block mb-2 text-sm font-medium text-stone-200">
                                                                  Your Email ID
                                                            </label>
                                                            <input type="email" name="email" className="theme-input" placeholder="name@company.com" required value={formData.email} onChange={handleChange} />
                                                      </div>

                                                      {/* Password Field */}
                                                      {/* <div>
                                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                                  Password
                                                            </label>
                                                            <input type="password" name="password" className="border border-gray-200 text-gray-900 rounded-lg focus:ring-amber-600 focus:border-amber-600 block w-full py-2 px-4" placeholder="••••••••" required value={formData.password} onChange={handleChange} />
                                                      </div> */}
                                                      <div className="relative">
                                                            <label className="block mb-2 text-sm font-medium text-stone-200">
                                                                  Password
                                                            </label>
                                                            <input
                                                                  type={showPassword ? "text" : "password"}
                                                                  name="password"
                                                                  className="theme-input pr-10"
                                                                  placeholder="••••••••"
                                                                  required
                                                                  value={formData.password}
                                                                  onChange={handleChange}
                                                            />

                                                            {/* Eye Icon */}
                                                            <div
                                                                  onClick={() => setShowPassword(!showPassword)}
                                                                  className="absolute right-3 top-[38px] cursor-pointer text-stone-300"
                                                            >
                                                                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </div>
                                                      </div>

                                                      {/* Remember Me & Forgot Password */}
                                                      <div className="flex items-center justify-between">
                                                            <div className="flex items-center">
                                                                  <input type="checkbox" name="remember" className="h-4 w-4 rounded border border-amber-400/40 bg-transparent" checked={formData.remember} onChange={handleChange} />
                                                                  <label className="ml-2 text-sm text-stone-300">
                                                                        Remember me
                                                                  </label>
                                                            </div>
                                                            <Link to="/forgot_password_email" className="text-sm font-medium text-amber-600 hover:underline">
                                                                  Forgot password?
                                                            </Link>
                                                      </div>

                                                      {/* Submit Button */}
                                                      <button type="submit" className="theme-btn-primary w-full px-5 py-2.5 text-center text-sm" disabled={loading} >
                                                            {loading ? "Signing in..." : "Sign in"}
                                                      </button>
                                                      {/* Signup Link */}
                                                      <p className="text-sm text-center text-stone-300">
                                                            Don’t have an account yet?{" "}
                                                            <Link to="/signup" className="font-medium text-amber-400 hover:underline">
                                                                  Sign up
                                                            </Link>
                                                      </p>
                                                </form>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>
                  <Footer />
            </>
      );
};

export default SignIn;
